const ACTIONS = {
  CALL_API: 'call-api',
  SUCCESS: 'success',
  ERROR: 'error',
  SET_INITIAL_DATA: 'set-data',

  TEXT_CHANGE: 'text-change',
  TEXT_SET_ERRORS: 'text-set-errors',
  TEXT_REMOVE_ERRORS: 'text-remove-errors',

  DATE_CHANGE: 'date-change',
  DATE_SET_ERRORS: 'date-set-errors',
  DATE_REMOVE_ERRORS: 'date-remove-errors',
};

const formInfoReducer = (state, action) => {
  // //console.log("dispatch triggered", state, action);

  switch (action.type) {
    case ACTIONS.SET_INITIAL_DATA: {
      return {
        ...state,
        data: action.data,
        loading: action.loading
      };
    }

    // ----- TEXT -----
    case ACTIONS.TEXT_CHANGE: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            value: action.value,
            validation: {
              ...path.validation,
              isInvalid: false, // isInvalidFunc(path.validation.required, action.value)
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.TEXT_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.TEXT_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- DATES (startDate / endDate) -----
    case ACTIONS.DATE_CHANGE: {
      const path = state.data[action.name]; // "startDate" or "endDate"
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            value: action.value,
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }
    case ACTIONS.DATE_SET_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: action.errors != null ? true : false,
              errors: action.errors
            }
          }
        }
      };
    }
    case ACTIONS.DATE_REMOVE_ERRORS: {
      const path = state.data[action.name];
      return {
        ...state,
        data: {
          ...state.data,
          [action.name]: {
            ...state.data[action.name],
            validation: {
              ...path.validation,
              isInvalid: false,
              errors: []
            }
          }
        }
      };
    }

    // ----- API submission -----
    case ACTIONS.CALL_API: {
      return {
        ...state,
        loading: true,
        apiError: null
      };
    }
    case ACTIONS.SUCCESS: {
      return {
        ...state,
        loading: false,
        apiError: null,
        apiResponse: action.response
      };
    }
    case ACTIONS.ERROR: {
      return {
        ...state,
        loading: false,
        apiError: action.error
      };
    }
  }
};

export { ACTIONS, formInfoReducer };
